"use strict";

exports.__esModule = true;
exports.getXAxisTimestampLinearScale = void 0;
var getXAxisTimestampLinearScale = exports.getXAxisTimestampLinearScale = function getXAxisTimestampLinearScale(scale, left) {
  return scale.invert(left);
};